/**
 * date format
 * @param {*} date
 * @param {*} fmt
 */
export function dateFormat(date, fmt = "yyyy-MM-dd hh:mm:ss") {
  //author: meizz
  var o = {
    "M+": date.getMonth() + 1, //月份
    "d+": date.getDate(), //日
    "h+": date.getHours(), //小时
    "m+": date.getMinutes(), //分
    "s+": date.getSeconds(), //秒
    "q+": Math.floor((date.getMonth() + 3) / 3), //季度
    S: date.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  return fmt;
}

// 获取当前时间的前三个月的时间
export function get3MonthBefor() {
  let resultDate, year, month, date;
  let currDate = new Date();
  year = currDate.getFullYear();
  month = currDate.getMonth() + 1;
  date = currDate.getDate();
  switch (month) {
    case 1:
    case 2:
    case 3:
      month += 9;
      year--;
      break;
    default:
      month -= 3;
      break;
  }
  month = month < 10 ? "0" + month : month;
  date = date < 10 ? "0" + date : date;
  resultDate = year + "-" + month + "-" + date;
  return resultDate;
}

// 获取当前日期
export function getNowFormatDate() {
  const date = new Date();
  const seperator = "-";
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  const currentdate = date.getFullYear() + seperator + month + seperator + strDate;
  return currentdate;
}
